export const methode = {
  title: 'Blink Nederlands Jaar 1',
  image: './img/blink-nederlands.png',
  children: {
    'Startles': {
      children: {
        'Wat is Nederlands?': {
          description: 'In de startles maken leerlingen kennis met het vak Nederlands en PLOT26. Door middel van acht verrassende filmpjes denken ze na over wat Nederlands is en wat het vak Nederlands inhoudt.',
          image: '//lh3.googleusercontent.com/_rCgVEy8tqCZ73MygUspcq73d3rVCw_NY5dvxUrZ7d5CpnaOQkA_oFWb3W_miViH_bUeprS-Ld80v6-vCSj8Ysv_7JiE=w160-h170-c',
          tags: [
            '2A1', '2A2', '2A5', '3B2', '5A1', '8A1', '8A2'
          ]
        }
      }
    },
    'Brugklas': {
      class: 'type-story',

      children: {
        'Wat is er nieuw op school?': {
          description: '',
          tags: [
            '2A1', '2A2', '2A3', '2A4', '2A5',
            '2B1', '2B4', '2B5',
            '3B2',
            '4A1', '4A2',
            '5A2',
            '7A1',
            '8A1', '8A2', '8A4',
            '8B1', '8B2', '8B3',
            '9A1', '9A2'
          ]
        },
        'De eerste indruk': {
          description: '',
          tags: [
            '2A1', '2A2', '2A3', '2A5',
            '2B1', '2B2', '2B4', '2B5',
            '3B2',
            '4A1', '4A2', '4B1',
            '5A2', '5A4',
            '7A1',
            '8A1',
            '8B1', '8B2', '8B3',
            '9A1', '9A2'
          ]
        },
        'Hoe ontstaan vriendschappen?': {
          description: '',
          tags: [
            '2A1', '2A2', '2A3', '2A4', '2A5', '2A6',
            '2B1', '2B2', '2B4', '2B5',
            '3B2',
            '4A1', '4A2', '4B1',
            '5A1', '5A2',
            '8A1', '8B1', '8B2', '8B3',
            '9A1', '9A2'
          ]
        },
        'Bij wie hoor ik?': {
          description: '',
          tags: [
            '2A1', '2A2', '2A3', '2A4', '2A5', '2A6',
            '2B1', '2B5',
            '3B2',
            '4A1', '4A2', '4B1',
            '5A2',
            '8A1', '8A2', '8A4',
            '8B1', '8B2', '8B3',
            '9A1', '9A2'
          ]
        },
        'Hoe blijf je trouw aan jezelf?': {
          description: '',
          tags: [
            '2A1', '2A2', '2A3', '2A5', '2A6',
            '2B4', '2B5',
            '3B2', '3C3',
            '4A1', '4A2', '4A3', '4A5', '4B1', '4B2', '4B3',
            '5A2',
            '8A1', '8B1', '8B2', '8B3',
            '9A1', '9A2'
          ]
        },
        'Wat zijn mijn kwaliteiten?': {
          description: '',
          tags: [
            '2A1', '2A2', '2A3', '2A4', '2A5', '2A6',
            '2B5',
            '3B2', '3C3',
            '4A1',
            '5A2',
            '8A1', '8B1', '8B2', '8B3', '8B4',
            '9A1', '9A2'
          ]
        },
        'Poster over jezelf': {
          description: '',
          tags: [
            '3A1', '3A4', '3A5',
            '3B2', '3C3', '3C5',
            '4A1', '4A2', '4B1', '4B5',
            '5A1', '5A2', '5A3',
            '6B1', '6B4', '6B5',
            '7A1', '7A3', '7A5',
            '8B2'
          ]
        }
      }
    },
    'De Kooi': {
      class: 'type-story',
      description: 'Achter een oude kooi gaat een mysterie schuil dat de leerlingen gaan ontrafelen. Ze komen terecht op de site van een geheimzinnig Genootschap, waar ze via taalgames een gevaarlijke kraai uitschakelen.',
      children: {
        'De brief': {
          image: '//lh3.googleusercontent.com/svVfVoJ2mqOAqTL5VH_2ydRVL8D4SCkXWKkJqAyqmZ37FbxRVRLToBfPyHXN8LwgxmsurVibtRxj_nqM03rSu5f9oQ=w150-h150-c',
          description: 'De leerlingen lezen het eerste deel van het verhaal. Ze ontcijferen de brief, die Annika voor haar deur gevonden heeft. Onder de bloedspatten staan de signaalwoorden. Vervolgens lezen ze deel 2 van het verhaal, dat eindigt met een cliffhanger: een nieuwsbericht.',
          tags: ['2A1', '2A2', '2A3', '2A5', '2A6', '2B1', '3C1', '6A4', '8A1', '8B1', '9A1', '9A3']
        },
        'De veer': {
          description: 'Leerlingen lezen het nieuwsbericht over het bizarre ongeluk. Daarna lezen ze deel 3 van het verhaal waarin Annika de gevonden veer laat onderzoeken. Ze krijgen de drie symbolen op de veer te zien. Met behulp van een filmpje, en artikel en een luisterfragment achterhalen ze de betekenis van deze symbolen.',
          image: '//lh3.googleusercontent.com/R9r_ASLOlosRJ4lDoXCGuUylQyJt0SpkeJWnhKlheH-nWB76lDq2G82AiAmvK7f8h7IxTk-0BO7adXwDqkUSOzlrKhI=w150-h150-c',
          tags: ['2A1', '2A2', '2A3', '2A5', '2A6', '2B1', '2B2', '2B4', '3B2', '3C1', '3C3', '4A1', '4A2', '8A1', '9A1', '9A3']
        },
        'De e-mail van Kinnaro': {
          description: 'In deel 4 van het verhaal lezen ze dat Annika een e-mail krijgt van Kinnaro. Ze moeten een antwoordmail schrijven. Ze bespreken hun mails en uiteindelijk dicteren de leerlingen de ‘ideale’ mail aan de docent. De docent stuurt het antwoord naar Kinnaro, die meteen antwoordt met een vrij dreigende mail.',
          tags: ['2A1', '2A2', '2A3', '2A5', '2B1', '3A1', '3A2', '3A5', '3C1', '4A1', '4A2', '4B1', '4B3', '5A1', '5A2', '6A4', '8A1', '9A1'],
          image: '//lh3.googleusercontent.com/3ILy05ZOVcIn8QUzTxzcSxOoou1LxAu6h1n6djuTZoVpJ5ggfwitQqorqlq-iQyYx4gYzEGOE__Ptl-xC64boxSx4Z8=w150-h150-c'
        },
        'Wie is Kinnaro?': {
          description: 'De leerlingen lezen deel 5 van het verhaal. Hierin zoekt Annika informatie over Kinnaro. Leerlingen lezen de Wikipediapagina die Annika heeft gevonden en ze zoeken de moeilijke woorden op. Op de pagina staat iets over het Genootschap van Gelijkheid. Annika zoekt in Google, klikt op de link en komt op de site',
          image: '//lh3.googleusercontent.com/mFdbId79Xf7-QSwBvaAwl_A8acSLCw0jtyvrX9mQrQ3h9XrgUYLWS-O2s2qL7L2Coz_yKYDKQ2E5Lv8Mib9BIZhZ0A=w150-h150-c',
          tags: ['2A1', '2A3', '2A5', '2A6', '2B1', '3A1', '3C1', '4A1', '4A2', '5A2', '8A1', '9A1']
        },
        'Opa\'s verhaal': {
          description: 'Leerlingen vullen het webformulier op de site van het Genootschap in. Met de drie symbolen uit les 2 krijgen ze toegang tot de website. Ze bekijken de videoboodschap van opa aan Annika. Ze zetten de gebeurtenissen die opa beschrijft, in chronologische volgorde. Ze maken de eerste twee tests op de site.',
          image: '//lh3.googleusercontent.com/FVHwZMP35uhE7cAiHObn5GkVD3tAIvHdRs0rbG7-BbtB0TmVB7gR6TtPjqmw3T-Jc96OXJkJUWRvY7rRjdMlErw_3sM=w150-h150-c',
          tags: ['2A1', '2A2', '2A3', '2A5', '2A6', '2B1', '3A1', '5A2', '6A4', '8A1', '9A1']
        },
        'De kraai uitgeschakeld': {
          description: 'Leerlingen gaan verder op de site van het Genootschap van Gelijkheid. Ze maken test 3, 4 en 5. Als ze slagen voor de tests, krijgen ze niet alleen beloningsfoto’s, maar slagen ze er ook in de kraai in zijn kooi te krijgen.',
          image: '//lh3.googleusercontent.com/kJbSAIKwNG1UBimfusZ2UEh6IwcH4_XXcEfXgmqOOCRr6yB7p_S3zoZ5zLgTGi2Cy_qB_0kKjh5tBQZ70UBwJ8vlOA=w150-h150-c',
          tags: ['2A1', '2A2', '2A3', '2A5', '2A6', '2B1', '2C3', '3A1', '6A1', '6A2', '8A1', '9A1', '9A4']
        },
        'Een trailer of nieuwsbericht maken (1)': {
          description: 'Leerlingen kiezen een eindproduct: het verhaal van De kooi vertellen in een trailer of in een nieuwsbericht. Ze denken na over wat ze in welke volgorde willen vertellen en bekijken toolboxen. Ze maken een nieuwsbericht of trailer.',
          image: '//lh3.googleusercontent.com/Efdn63S4iWHXaWGUFhXCRm-_EP4_cC3NXgAZ7j-uyOxYoYsp1cHWPvgt73N0pDSi3vlTEFBP58cBJcOdeaQKRzpGvFU=w150-h150-c',
          tags: ['2A1', '2A2', '2A3', '2A5', '2B1', '3A1', '3A2', '3B1', '3B2', '3B3', '3B4', '3C3', '4A2', '5A2', '6A4', '8A1', '9A1']
        },
        'Een trailer of nieuwsbericht maken (2)': {
          description: 'Leerlingen kiezen een eindproduct: het verhaal van De kooi vertellen in een trailer of in een nieuwsbericht. Ze denken na over wat ze in welke volgorde willen vertellen en bekijken toolboxen. Ze maken een nieuwsbericht of trailer.',
          image: '//lh3.googleusercontent.com/Efdn63S4iWHXaWGUFhXCRm-_EP4_cC3NXgAZ7j-uyOxYoYsp1cHWPvgt73N0pDSi3vlTEFBP58cBJcOdeaQKRzpGvFU=w150-h150-c',
          tags: ['2A1', '2A2', '3A1', '3A5', '3B1', '3B2', '3B3', '3B4', '3C3', '4A1', '4A2', '4B1', '5A1', '5A2', '5A3', '6A4', '8A1']
        },
        'Terugblik': {
          description: 'Leerlingen leveren hun eindproduct in. Ze bespreken wat ze geleerd hebben aan de hand van de afbeelding met de domeinen. Ze doen mee aan de quiz ‘Zinnige en onzinnige vragen over De kooi’.',
          image: '//lh3.googleusercontent.com/ESJ86KS0wVfFJRh3uK68m3V4buiCDPfMAKV3FWObrGzXrgzrPG1_MFUxOyNFnPfWXZG9oozo4ZMWICFJruAPGwyXJw=w150-h150-c',
          tags: ['2B5', '3A1', '3A4', '3B2', '4A1', '4A2', '4B1', '4B5', '5A1', '5A2', '5A3', '6B1', '8B1']
        }
      }
    },
    'Hypes': {
      class: 'type-course',
      children: {
        'Oude en nieuwe hypes': {
          description: '',
          tags: ['2A1', '2A2', '2B2', '2B4', '2B5', '3B2', '3C3', '4A1', '4A2', '4B2', '4B3', '5A1', '5A2', '5A3', '5A4', '6A4', '6B4']
        },
        'Een hype voor iedereen?': {
          description: '',
          tags: ['2A1', '2A2', '2A3', '2A4', '3A1', '3A2', '3A3', '3A5', '3B2', '3C3', '4A1', '4A2', '4B2', '4B3', '5A1', '5A2', '5A3', '6B1', '6B4', '6B5']
        },
        'Wie zit erachter?': {
          description: '',
          tags: ['2A1', '2A2', '2A3', '2A4', '2B5', '3A1', '3A2', '3A3', '3A5', '3B2', '3C3', '4A1', '4A2', '4B1', '4B2', '4B3', '5A1', '5A2', '5A3', '6A4', '6B1', '6B4', '6B5']
        },
        'Eendagsvlieg of blijvertje?': {
          description: '',
          tags: ['2A1', '2A2', '2A3', '2A4', '2B5', '3A1', '3A2', '3A3', '3A5', '3B2', '3C3', '4A1', '4A2', '4B1', '4B2', '4B3', '4B5', '5A1', '5A2', '5A3', '5A4', '6A4', '6B1', '6B3', '6B4', '6B5', '7A3', '7A5']
        },
        'Minitijdschrift (1)': {
          description: '',
          tags: ['3A1', '3A4', '3A5', '3B2', '3C1', '3C3', '4A1', '4A2', '4B2', '4B3', '5A1', '5A2', '5A3', '5A4', '6A4', '6B1', '6B3', '6B4', '6B5']
        },
        'Minitijdschrift (2)': {
          description: '',
          tags: ['3A1', '3A4', '3A5', '3B2', '3C3', '4A1', '4A2', '4B1', '4B5', '5A2', '5A3', '5A4', '6A4', '6B1', '6B3', '6B4', '6B5']
        }
      }
    },
    'Verdacht': {
      class: 'type-story',
      description: 'Vanaf dit schooljaar heeft het verhaal in de lessenserie Verdacht een andere dader! Leerlingen lossen in dit verhaal een moord op. Om dichter bij de oplossing te komen, moeten ze al hun taalvaardigheden inzetten.',
      children: {
        'Verdacht':{
          description:'De leerlingen lezen een Facebookbericht en bekijken het bijbehorende filmpje. Ze lezen het verhaal Verdacht.',
          image:'//lh3.googleusercontent.com/gEGrHL1pIEiqzVzCJC3LeMXKkqGZYb7vmZXEREAqYHbubHipVLM7o2nx8hXVgpsUgWuc_5lYMSfdezc5O2faSlVfKk1J=w150-h150-c',
          tags:[
            '2A1', '2A2', '2A3', '2A4', '2A5', '2B1', '3B1', '8A1', '8B1', '9A1', '9A2', '9A3', '9A4'
          ]
        },
        'Hulp gevraagd':{
          description:'De leerlingen bekijken het bericht van Caja en maken aantekeningen. Ze maken groepen en verdelen de rollen (in vmbo-b geen rollen). Ze bekijken de eerste getuigenverklaring.',
          image:'//lh3.googleusercontent.com/ahLkMcNJDVeO5TpOIZ7WD2V1TT5WayLyfjUNmmCkwFw0G1175epf-GhL-v9CsRHmAREpGySiBeClL2uH5K9gKpz7dhk=w150-h150-c',
          tags:[
            '2A1', '2A2', '2A4', '2A5', '2B1', '2B2', '3A1', '3C1', '4A1', '4A2', '4B1', '4B2', '8B1'
          ]
        },
        'Getuigenverklaringen':{
          description:'De leerlingen bekijken alle getuigenverklaringen en vullen een kijkformulier in. Ze trekken een conclusie over welke getuige liegt',
          image:'//lh3.googleusercontent.com/4-aUP8ZzwYdiK2cuOQFkk7zgEOlWGXioqxACtMGx0ahhjnwt-naCnWylChZadljBDnMJJdVVO-PZC4uY-5I9oJ8yk4A=w150-h150-c',
          tags:[
            '2A1', '2A2', '2A4', '2A5', '2B1', '2B2', '3A1', '3C1', '4A1', '4A2', '4B1', '4B2', '8B1', '9A1', '9A2', '9A4'
          ]
        },
        'Informatie ontfutselen':{
          description:'De leerlingen bekijken het bericht van Caja en maken aantekeningen. Ze schrijven een formele e-mail. Ze geven elkaar feedback en verwerken de ontvangen feedback in hun e-mail.',
          image:'background-image: url("//lh3.googleusercontent.com/E81eGs2xr2JhPvpwzyh9Aa8_9ELhsVmV-33PA_AIMWoplp-Xdf09KU4BKuFLhaJ2AFAhcZmKz_HF8txBe7njBEo31Ek=w150-h150-c',
          tags:[
            '2A1', '2A2', '2A3', '2A5', '3A1', '3A2', '3A3', '3A5', '4A1', '4A2', '5A1', '6A4', '6B1'
          ]
        },
        'Het politiedossier':{
          description:'De leerlingen bekijken het bericht van Caja en maken aantekeningen. Ze lezen het complete politiedossier. Ze maken een taakverdeling. Ze maken een samenvatting',
          image:'//lh3.googleusercontent.com/E81eGs2xr2JhPvpwzyh9Aa8_9ELhsVmV-33PA_AIMWoplp-Xdf09KU4BKuFLhaJ2AFAhcZmKz_HF8txBe7njBEo31Ek=w150-h150-c',
          tags:[
            '2A1', '2A2', '2A3', '2A5', '2A6', '2B1', '2B2', '2B4', '3A2', '3C1', '4A1', '4A2', '4B1', '4B2', '8B1', '9A1', '9A2', '9A4'
          ]
        },
        'Reconstructie maken':{
          description:'De leerlingen bekijken het bericht van Caja en maken aantekeningen. Ze maken een reconstructie van de moord en bedenken het motief voor de moord',
          image:'//lh3.googleusercontent.com/W8IgA4DnExI8VjVjja6iFGLjqpEoXFKd3sRf5akmeMJE_23P3StMBZK-QKy2GeaYheXuOjEVWZlARfyO8DVIeK2LprQ=w150-h150-c',
          tags:[
            '2A1', '2A2', '2A5', '2B1', '2B2', '3A1', '3A2', '3C1', '4A1', '4A2', '4B1', '4B2', '5A1', '8B1', '9A1', '9A2', '9A4'
          ]
        },
        'Presentatie voorbereiden':{
          description:'De leerlingen bereiden een presentatie voor.',
          image:'//lh3.googleusercontent.com/KKFdapv9NSMiapyotY1gqu6BNv3tWfn3AxROfN1EcdLerlj11e4A1fCzKJqjmFWzozVa5ax78su5_Ercs_YCVuNyExut=w150-h150-c',
          tags: [
            '2A2', '3A1', '3A2', '3A3', '3A4', '3A5', '4A1', '4A2',
            '4A3', '5A1', '6A4', '8B1'
          ]
        },
        'Presentaties':{
          description:'Ze houden een presentatie. Ze beoordelen elkaar.',
          image:'//lh3.googleusercontent.com/a7zioUooj0dS98Rj1NyAjD9YZjYvcA3NtLPwNtHwcVH725rVZhggBkPOXMF_8HOVmn4jFBUgiJWvLkdVMb515gLmc9kz=w150-h150-c',
          tags: [
            '2A1', '2A2', '2B1', '2B2', '3A1', '3A4', '4A1', '4A3',
            '5A1', '8B1'
          ]
        },
        'Terugblik':{
          description:'De leerlingen bespreken wat ze geleerd hebben.',
          image:'//lh3.googleusercontent.com/qOTya4xn6RqmxkxewMxfkC3K3YiBQRx3T_Z2_2luRzFUoTrH4nS5wuQpXF1FMMcYfWc-cw2mzli4OfgCxHiaD8nL7a4=w150-h150-c',
          tags:[
            '2A1', '2A2', '2B1', '2B2', '3A1', '3C1', '4A1', '4A2', '5A1', '6A4'
          ]
        }
      }
    },
    'Basisgrammatica 1': {
      class: 'type-course',
      children: {
        'De zin als miniverhaal': {
          tags: ['2A1', '2A2', '4A2', '4B3', '6A3']
        },
        'Werkwoorden in actie': {
          tags: ['2A2', '2B5', '3B2', '6A3', '6B1']
        },
        'Meer in je zin stoppen': {
          tags: [
            '2A2', '2B5', '3B2', '4A2', '4B2', '6A3', '6A5', '6B1'
          ]
        },
        'Zinnen aan elkaar plakken': {
          tags: ['2A2', '2B5', '6A3', '6B1']
        },
        'Alles onder controle': {
          tags: ['5A2', '6A3', '6B1']
        }
      }
    },
    'Alert': {
      class:'type-story',
      description:'Vijf leerlingen zijn vermist tijdens een schoolkamp. Als ze eindelijk gevonden worden in een grot, blijkt het niet om een \'gewone\' vermissing te gaan. Leerlingen zoeken uit wat er is gebeurd.',
      children:{
        'De omslag':{
          description:'De leerlingen analyseren vier flapteksten. Ze lezen de flaptekst van Alert en lezen deel 1 van het verhaal.',
          image:'//lh3.googleusercontent.com/OVyKBSsalIjyvhmYG4sT47WzwL2QDjzc-DbNwaFJZKKw5d_F-aoIdgieszDmw9QRYdCIdMR1qy2tNveiyEelsNps29U=w150-h150-c',
          tags: [
            '2A1', '2A2', '2B2', '2B4', '2B5', '3B2', '3C3', '6C1',
            '6C2', '6C3', '8A1', '8A2', '8A4', '9A1', '9A2', 'm1',
            'm39', 'm40', 'm41', 'm47'
          ]
        },
        'Alert':{
          description:'De leerlingen lezen deel 2 van het verhaal. Ze bekijken video-opnames van een politiebureau en schrijven een alertbericht. Ze lezen getuigenverklaring (tien verschillende) en leven zich in het personage in. Ze verwerken de informatie uit hun tekst in een voicemailbericht (voorbereiding)',
          image:'//lh3.googleusercontent.com/2q2N_5oe1EFQP8EtHDxbhJXdnN1vtRx6QIwBcAjc4we_Q3yAI4iDrAvYJ0DHd-PmIff2pR3EuhtWPNnFXD1ZVauYSE8=w150-h150-c',
          tags: [
            '2A1', '2A2', '2B4', '2B5', '3A1', '3A5', '3B2', '3C3',
            '4B1', '6C1', '6C2', '6C3', '8A1', '9A1', '9A2', '9A3',
            'm16', 'm17', 'm18', 'm19', 'm20', 'm21', 'm26', 'm30',
            'm34', 'm35', 'm36', 'm37'
          ]
        },
        'Meer informatie':{
          description:'De leerlingen spreken hun boodschap in. Ze maken aantekeningen bij de andere boodschappen. Ze maken op basis van de voicemailberichten een tijdlijn van de gebeurtenissen.',
          image:'//lh3.googleusercontent.com/lt2qXQvcMPv7FEKRmC0wKDHcXwH8xd5QfkhAKCMIxXXaSWqYukorrPX6jcw5Jd043q6f99izJGF7w45MTuKHO_0tMTI=w150-h150-c',
          tags: [
            '2A1', '2A2', '3A4', '3B2', '3C3', '4A3', '4B1', '9A1',
            '9A4', 'm14', 'm16', 'm17', 'm19', 'm20', 'm29', 'm30',
            'm34', 'm36', 'm37', 'm44', 'm45', 'm57', 'm68'
          ]
        },
        'Chaos in de grot':{
          description:'De leerlingen lezen deel 3 van het verhaal. Ze lezen vier teksten en bekijken welke het best bij het verhaal past. Ze lezen deel 4 van het verhaal en bekijken een video-animatie. Ze controleren of hun inschatting (welke tekst past bij het verhaal) klopte.',
          image:'//lh3.googleusercontent.com/F8R_yBhgdiIQxamdognA_fSfUy9VOIVbwZmgoHjMPJCT37TlYNGjUFs5c6Da0HlE9nE4pXi9ZtMsi9Ka13o2poeoUJ9H=w150-h150-c',
          tags: [
            '2A1', '2A2', '2B2', '2B4', '2B5', '3B2', '4B1', '8A1',
            '8B1', '9A1', '9A2', '9A4', 'm18', 'm21', 'm22', 'm26',
            'm39', 'm40', 'm42', 'm46', 'm49'
          ]
        },
        'Wie wel, wie niet?':{
          description:'De leerlingen lezen deel 5 van het verhaal. Ze verplaatsen zich in de hoofdpersonen en bespreken met elkaar wat zij zouden doen. Ze presenteren hun keuze en hun argumenten voor de klas.',
          image:'//lh3.googleusercontent.com/GMqWMIOvbrAzZEKVMWrudUD9_LwvJCr6d6jEA0exnMVBzOTevPFnq_JYufY3A6qwA54waGWvp5K6QwJ6PokKwDHJ_azB=w150-h150-c',
          tags: [
            '2A1', '2A2', '3A4', '3B2', '3C3', '4A3', '4B1', '8A1',
            '8B2', '8B3', '9A1', '9A2', '9A4', 'm1', 'm2', 'm3',
            'm4', 'm6', 'm31', 'm34', 'm35', 'm36', 'm37', 'm56',
            'm59'
          ]
        },
        'En toen…':{
          description:'De leerlingen lezen deel 6 van het verhaal. Ze luisteren naar de ingesproken routebeschrijving en tekenen de route. Ze lezen de flaptekst van Alert nog een keer en bedenken zelf het einde van het verhaal. Ze kiezen een eindopdracht: het einde van het verhaal schrijven in de vorm van een verhaal of een nieuwsbericht',
          image:'//lh3.googleusercontent.com/J4G3I8lUYLRL1Ky8Q0NUAsOdcfQDFW5x3mObEQxRGf6uy5Nx6Q5_i8_xc5-PnbPPT8AgX168aSSpIwaMgSqotgs_sDE=w150-h150-c',
          tags: [
            '2A1', '2A2', '3B1', '3B2', '3C3', '4B1', '6C1', '6C2',
            '8A1', '9A1', '9A2', '9A3', '9A4', 'm14', 'm16', 'm19',
            'm20', 'm21', 'm22', 'm30', 'm39', 'm40', 'm44', 'm45'
          ]
        },
        'Schrijven maar…':{
          description:'De leerlingen bespreken de criteria voor de tekst. Ze schrijven het verhaal of het nieuwsbericht',
          image:'//lh3.googleusercontent.com/D2Ln-i5-xVPP1ayyIGdNgmk-BnXwnIN5JmzSjCwjqVu43iX7F4USPQ_l4p4vKYNFRQ96Z1CcwlZeEPgxDDRXYVQh5go=w150-h150-c',
          tags: [
            '3A1', '3A3', '3B2', '6C1', '6C3', '9A3', '9B1', 'm27',
            'm63', 'm65', 'm73', 'm75', 'm76', 'm77', 'm78'
          ]
        },
        'Tekst verbeteren':{
          description:'Ze geven elkaar feedback en verbeteren hun tekst. Ze leveren de definitieve tekst in.',
          image:'//lh3.googleusercontent.com/8jaVEq1muao1PdrWu7USXHEbcbXLPl6PNGLPWmfOm6SVJLl1iY7N3tFjJE5-ynRlHuCvIVPOX3U8LMeHD2jmwr_TXA=w150-h150-c',
          tags: [
            '3A5', '5A1', '4A1', '4B1', '6C3', '9B1', '9B2', 'm2',
            'm3', 'm4', 'm6', 'm21', 'm27', 'm63', 'm65', 'm75',
            'm76', 'm77', 'm78'
          ]
        },
        'The end':{
          description:'De leerlingen presenteren hun definitieve tekst en beoordelen elkaars schrijfproduct. Ze lezen deel 7 van het verhaal. Ze bespreken wat ze geleerd hebben.',
          image:'//lh3.googleusercontent.com/Ze-2-EZY3BgO37IsQBDLN61YPaJXwKLoolh_cyLnV-52s_ZvmgGazdaqU1HVd8qXR-pfkSlEUXx5SKQL_54q2KZcYig=w150-h150-c',
          tags: [
            '2A1', '2B4', '2B5', '3A4', '3B2', '4A3', '5A1', '6C3',
            '8A1', '8A2', '8B1', '9A1', '9A2', '9A3', '9B2', 'm2',
            'm6', 'm27'
          ]
        }
      }
    },
    'Noodsituaties': {
      class: 'type-story',
      children: {
        'Bangmakerij?': {
          tags: [
            '2A1', '2A2', '2A3', '2A5', '2B2', '2B5', '4A2', '4A5',
            '4B4', '5A2'
          ]
        },
        'Presteren onder tijdsdruk': {
          tags: [
            '2A1', '2A5', '2A6', '2B1', '4A2', '4B3', '5A2'
          ]
        },
        'De diepte in': {
          tags: [
            '2A1', '2A2', '2A4', '2A5', '2A6', '2B1', '2B5', '2C1',
            '3C1', '5A2'
          ]
        },
        'Je online redden': {
          tags: [
            '2A1', '2A3', '2A5', '2A6', '2B1', '2B5', '2C2', '2C3',
            '4B2', '5A2'
          ]
        },
        'Wat een verhaal!': {
          tags: [
            '2A1', '3A1', '3A5', '3B2', '3B3', '3B4', '3B5', '5A1',
            '5A2', '6B2', '8B3'
          ]
        },
        'In het nieuws': {
          tags: [
            '3A3', '3A5', '5A1', '5A2', '6B1', '6B2', '6C1'
          ]
        },
        'Survivalgids (1)': {
          tags: [
            '2A1', '2A3', '2A4', '2B1', '2B5', '3A1', '3A2', '3A3',
            '3C3', '4A2', '5A2', '6C1', '6C2', '6C3', '7A2'
          ]
        },
        'Survivalgids (2)': {
          tags: [
            '3A1', '3A3', '3A5', '5A1', '5A2', '6B1', '6B2', '6B5'
          ]
        },
        'Survivalgids (3)': {
          tags: [
            '3A5', '5A1', '5A2', '5A3', '5A4', '6B1', '6B2', '6B3',
            '6B5', '7A1', '7A2'
          ]
        }
      }
    },
    'Termeh': {
      class: 'type-story',
      children: {
        'Gouden tijden': {
          tags: [
            '2A1', '2A2', '2A5', '2B4', '2B5', '4A1', '4A2', '8A1',
            '8A2', '8B1', '9A1', '9A2'
          ]
        },
        'Wie beslist?': {
          tags: [
            '2A1', '2A2', '2B2', '2B5', '3B2', '4A1', '4A2', '9A2',
            '9A3'
          ]
        },
        'Dromen van een andere wereld': {
          tags: [
            '2A1', '2A2', '2A4', '2A5', '3B2', '4A1', '4A2', '8B2',
            '8B4', '9A1', '9A2', '9A3', '9A4'
          ]
        },
        'Schreeuwen in stilte': {
          tags: [
            '2A1', '2A2', '2A5', '2B5', '3B2', '3B3', '3B5', '4A1',
            '4A2', '7A1', '8B2', '8B3', '9A1', '9A2', '9A3'
          ]
        },
        'Kalm van buiten': {
          tags: [
            '2A1', '2A2', '2A3', '2A5', '2B5', '3B2', '4A1', '4A2',
            '8B2', '9A1', '9A2', '9A3'
          ]
        },
        'Vrij als een vogel': {
          tags: [
            '2A1', '2A2', '2A5', '3B2', '4A1', '4A2', '7A1', '8B2',
            '8B4', '9A1', '9A4', '9B3'
          ]
        },
        'Jij en Termeh': {
          tags: [
            '2A1', '2A2', '2A5', '3B2', '4A1', '4A2', '7A1', '8B2',
            '8B4', '9A1', '9A4', '9B3', '3A1', '3A2', '3A4', '3A5',
            '3B3', '3C3', '4B1', '5A1', '5A2', '5A3', '8B1', '9A2'
          ]
        },
        'Afsluiting': {
          tags: [
            '2A1', '4A1', '4A2', '4A3', '4B5', '5A1', '5A2', '7A3',
            '8A2', '8A3', '8B1', '8B2', '8B4'
          ]
        }
      }
    },
    'Verzwegen': {
      class: 'type-story',
      children: {
        'De uitreiking': {
          tags: [
            '2A1', '2A2', '2A3', '2A4', '2A5', '2A6', '2B2', '2B3',
            '2B5', '3A1', '3A3', '3A4', '4A2', '4A3', '4A5', '4B1',
            '4B2', '4B3', '6D2', '6D3', '6D4', '8A1', '8B3', '8B4',
            '9A1', '9A2', '9A4'
          ]
        },
        'Met de reacties naar oma': {
          tags: [
            '2A1', '2A2', '2A4', '2A5', '2B1', '2B2', '2B4', '3A1',
            '3A2', '3A4', '3A5', '4A2', '4A5', '4B1', '4B2', '4B5',
            '5A1', '5A2', '5A3', '8A1', '8B1', '8B3', '8B4', '9A1',
            '9A2', '9A4'
          ]
        },
        '(Re)actie!': {
          tags: [
            '2A1', '2A2', '2A5', '2B1', '2B4', '2C1', '2C3', '3A1',
            '3A3', '3A5', '4A2', '4A5', '5A1', '5A3', '6B1', '6B4'
          ]
        },
        'Spoorzoeken': {
          tags: [
            '2A1', '2A2', '2A3', '2A4', '2A5', '2B1', '2B2', '2B3',
            '3C1', '3C3', '3C4', '4A2', '4A5', '4B1', '4B3', '4B5',
            '6A4', '7B5', '8A1', '8B2', '8B3', '8B4', '9A1', '9A2',
            '9A3', '9A4', '9C1', '9C2', '9C3', '9C4'
          ]
        },
        'Dagboek': {
          tags: [
            '2A1', '2A2', '2A4', '2A5', '2B1', '2B2', '2B5', '3B1',
            '3B2', '3B3', '3B5', '4A2', '4A5', '4B1', '4B3', '4B4',
            '8A1', '8B1', '8B2', '8B3', '8B4', '9A1', '9A2', '9A3',
            '9A4', '9B1', '9B3', '9C1', '9C2', '9C4'
          ]
        },
        'Dichter bij de waarheid': {
          tags: [
            '2A1', '2A5', '3A1', '3A2', '3A3', '3A4', '3B5', '4A1',
            '4A3', '4A5', '4B1', '4B2', '8B1', '8B3', '9A1', '9A2',
            '9A4'
          ]
        },
        'Interviews presenteren': {
          tags: [
            '2A1', '2B5', '3A4', '3A5', '4A2', '4A3', '4A5', '4B1',
            '4B3', '4B5', '5A1', '5A2', '5A3', '5A4', '8B1', '8B2',
            '8B3', '9A1', '9A2', '9A3'
          ]
        }
      }
    }
  }
}
